module.exports = __webpack_public_path__ + "static/media/messenger.460f28c1.svg";